var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AqtIndexZh"}},[_c('div',{staticClass:"right"},[_c('SearchIndex',{ref:"child",style:({height:_vm.$route.path=='/zhver'?'100%':'auto'})})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }